import { useEffect, useMemo } from 'react';
import { apiBaseUrl } from '../../config';
import { HttpTransportType, HubConnectionBuilder, JsonHubProtocol, LogLevel } from '@microsoft/signalr';
import { useClientMethod, useHub, useHubMethod } from 'react-use-signalr';

const UnitBoxDataTableSignalR = props => {

    const {
        token,
        companyId,
        requestBody,
        lastProcessedTimestamp,
        onIncomingData,
        onIncomingDataStop,
        refreshCounter
    } = props;

    const signalRConnection = useMemo(
        () => {
            const buildHubUrl = companyId
                ? `${apiBaseUrl}/ws/data?companyid=${companyId}`
                : `${apiBaseUrl}/ws/data`;

            const protocol = new JsonHubProtocol();
            const transport = HttpTransportType.WebSockets;

            const options = {
                skipNegotiation: true,
                transport,
                accessTokenFactory: () => token,
                headers: { authorization: token ? `Token ${token}` : `` },
            };

            return new HubConnectionBuilder()
                .withUrl(buildHubUrl, options)
                .withAutomaticReconnect()
                .withHubProtocol(protocol)
                .configureLogging(LogLevel.Information)
                .build();
        }, [token, companyId],
    );

    const {
        hubConnectionState,
        // error
    } = useHub(signalRConnection);
    const {
        invoke,
        // loading,
        // error: errorInvoke
    } = useHubMethod(signalRConnection, 'InitializeTimeBasedChannelDataForUnitsWithFilters');

    useClientMethod(signalRConnection, 'ChannelDataResponse', onIncomingData);
    useClientMethod(signalRConnection, 'LastTimestamp', onIncomingDataStop);

    useEffect(() => {
        if (requestBody && lastProcessedTimestamp && hubConnectionState === 'Connected') {
            invoke(requestBody, lastProcessedTimestamp).then();
        }
    }, [
        requestBody,
        lastProcessedTimestamp,
        invoke,
        hubConnectionState,
        refreshCounter
    ]);

    return null;
};

export default UnitBoxDataTableSignalR;
